import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  bar: {
    backgroundColor: 'white',
    margin: '0 auto',
    maxWidth: 1180,
    position: 'sticky',
    padding: `40px 26px 12px`,
    top: 50,
    zIndex: 100,
    [theme.breakpoints.down('lg')]: {
      top: 40,
    },
    [theme.breakpoints.down('md')]: {
      top: 50,
      padding: `${theme.spacing(2.5)} ${theme.spacing(1.5)} 12px`,
    },
  },
  title: {
    [theme.breakpoints.down('md')]: {
      fontSize: 22,
    },
  },
}));
